import { stringify } from 'qs';
import request from '@/services/request';
import { url } from './service-utils';


export async function getList(params) {
  return request(`${url.url}/v1/1157/health/code/list?${stringify(params)}`);
}
